import React from 'react';

import styles from 'components/prequalification/ExistingAccountLocatedLogIn/ExistingAccountLocatedLogIn.module.scss';

interface ExistingAccountLocatedLogInProps {
  mainContact?: { firstName: string; lastName: string; email: string };
}

const ExistingAccountLocatedLogIn = ({ mainContact }: ExistingAccountLocatedLogInProps) => {
  return (
    <>
      <div className={styles.text}>
        We can see that {mainContact?.firstName} {mainContact?.lastName}'s information has been previously submitted and
        we are currently waiting for additional information to be completed or cleared to finish onboarding process.
      </div>
      <div className={styles.text}>Please log in to review the current status of your account.</div>
    </>
  );
};

export default ExistingAccountLocatedLogIn;
